import { render } from "./UnauthorizedPage.vue?vue&type=template&id=ab611ee0"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=js"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=js"

import "./UnauthorizedPage.vue?vue&type=style&index=0&id=ab611ee0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__